import React from 'react'
import classNames from 'classnames'

import style from './style.scss'

type Props = React.HTMLProps<HTMLInputElement>

function Checkbox({ className, ...props }: Props) {
  return (
    <div className={classNames(style.wrapper, className)}>
      <input className={style.input} type='checkbox' {...props} />

      <span className={style.checkmark} />
    </div>
  )
}

export default Checkbox
